import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e3ab414"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["tabindex", "onKeydown", "onDragenter", "onDragleave", "onDrop"]
const _hoisted_2 = ["accept"]
const _hoisted_3 = { class: "an-dropzone-icon" }
const _hoisted_4 = { class: "an-dropzone-text" }
const _hoisted_5 = { class: "an-dropzone-hint" }

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'FileDropzone',
  props: {
    accept: {},
    disabled: { type: Boolean }
  },
  emits: ["select"],
  setup(__props: any, { emit }) {

const props = __props;


// `select` carries the accepted files plus how many were dropped with an unsupported type,
// leaving the parent to decide how to stage them and whether to warn.


const { t } = useI18n();
const input = ref<HTMLInputElement | null>(null);
const isDragging = ref(false);
// Counts nested dragenter/dragleave so hovering child nodes doesn't flicker the highlight.
let dragDepth = 0;

const open = (): void => {
    if (!props.disabled) input.value?.click();
};

const emitFrom = (list: FileList | null): void => {
    if (!list) return;
    const all = [...list];
    const accepted = all.filter((file) =>
        props.accept.some((ext) => file.name.toLowerCase().endsWith(ext.toLowerCase())),
    );
    emit('select', accepted, all.length - accepted.length);
};

const onChange = (event: Event): void => {
    const el = event.target as HTMLInputElement;
    emitFrom(el.files);
    el.value = ''; // reset so re-selecting the same file still fires change
};

const onDragEnter = (): void => {
    dragDepth += 1;
    isDragging.value = true;
};

const onDragLeave = (): void => {
    dragDepth -= 1;
    if (dragDepth <= 0) {
        dragDepth = 0;
        isDragging.value = false;
    }
};

const onDrop = (event: DragEvent): void => {
    dragDepth = 0;
    isDragging.value = false;
    if (!props.disabled) emitFrom(event.dataTransfer?.files ?? null);
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["an-dropzone", { 'is-dragging': isDragging.value, 'is-disabled': _ctx.disabled }]),
    role: "button",
    tabindex: _ctx.disabled ? -1 : 0,
    onClick: open,
    onKeydown: [
      _withKeys(_withModifiers(open, ["prevent"]), ["enter"]),
      _withKeys(_withModifiers(open, ["prevent"]), ["space"])
    ],
    onDragenter: _withModifiers(onDragEnter, ["prevent"]),
    onDragover: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isDragging.value = true), ["prevent"])),
    onDragleave: _withModifiers(onDragLeave, ["prevent"]),
    onDrop: _withModifiers(onDrop, ["prevent"])
  }, [
    _createElementVNode("input", {
      ref_key: "input",
      ref: input,
      type: "file",
      class: "an-visually-hidden",
      multiple: "",
      accept: _ctx.accept.join(','),
      onChange: onChange
    }, null, 40, _hoisted_2),
    _createElementVNode("span", _hoisted_3, [
      _createVNode(_component_font_awesome_icon, { icon: "file-import" })
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('addDecision.dropFilesHint')), 1),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('addDecision.acceptedTypesHint', { types: _ctx.accept.join(', ') })), 1)
  ], 42, _hoisted_1))
}
}

})